import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface CU02902State {
    isVisibleCU02902: boolean;
}

const initialState: CU02902State = {
    isVisibleCU02902: false,
};

export const CU02902Slice = createSlice({
    name: 'CU02902Slice',
    initialState,
    reducers: {
        setVisibleCU02902: (state) => {
            state.isVisibleCU02902 = !state.isVisibleCU02902;
        },
        resetCU02902Slice: () => initialState,
    },
});

export const { setVisibleCU02902 } = CU02902Slice.actions;

export default CU02902Slice.reducer;
